import { render, staticRenderFns } from "./MangheColor.vue?vue&type=template&id=60512f75&"
import script from "./MangheColor.vue?vue&type=script&lang=js&"
export * from "./MangheColor.vue?vue&type=script&lang=js&"
import style0 from "./MangheColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports